import * as React from 'react';
import {FieldData} from 'src/app/model/lighthouse/Common';
import FieldRenderer from 'src/app/component/lighthouse/review/FieldRenderer';

export interface CaseDetailsSectionProps {
    /** Array of case detail fields returned by the backend. */
    fields: FieldData[];
}

/**
 * Renders the "Case Details" section of the Lighthouse Review page.
 * Always read-only — displays case metadata (Transporter ID, Country, etc.)
 * that auditors observe but cannot edit.
 */
const CaseDetailsSection: React.FC<CaseDetailsSectionProps> = ({fields}) => {
    const hasFields = Array.isArray(fields) && fields.length > 0;

    return (
        <div className="lighthouse-section" data-testid="case-details-section">
            <div className="lighthouse-section-title">Case Details</div>
            {hasFields ? (
                <div className="lighthouse-section-content">
                    {fields.map(field => (
                        <FieldRenderer
                            key={field.label}
                            field={field}
                            readOnly={true}
                        />
                    ))}
                </div>
            ) : (
                <div className="lighthouse-section-empty" data-testid="case-details-empty">
                    No case details available.
                </div>
            )}
        </div>
    );
};

export default CaseDetailsSection;
